import React from "react";

import ContentNotFoundErrorBoundary from "@/content/utils/content-not-found-error-boundary";

import { UniformEntryPageProps } from "../../../../pages/uniform-entry/uniform-entry-page";
import { UniformWrapper } from "../../../../uniform/uniform-wrapper";

export const UniformEntryPageTemplate: React.FC<UniformEntryPageProps> = ({
    composition,
    isUniformPlayground
}) => {
    return (
        <ContentNotFoundErrorBoundary>
            <UniformWrapper
                composition={composition}
                isUniformPlayground={isUniformPlayground}
            />
        </ContentNotFoundErrorBoundary>
    );
};
